import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  legend: {
    fontSize: theme.typography.body1.fontSize,
    marginBottom: theme.spacing(1)
  },
  divider: {
    width: '100%',
    margin: theme.spacing(1, 0, 1, 0)
  },
  net: {
    padding: theme.spacing(2, 0.5, 0, 0)
  }
}));

export default useStyles;
